import { createPopulatedItemClientFactory, createPopulatedModifierGroupClientFactory } from './factoryCreator';
import { itemPopulationLevelNone, modifierGroupPopulationLevelNone } from '../utils/consts';
export const PopulatedItemClientFactory = _ref => {
  let {
    httpClient,
    populationLevel = itemPopulationLevelNone,
    getResolvedError,
    withErrorHandler
  } = _ref;
  return createPopulatedItemClientFactory({
    httpClient,
    populationLevel,
    getResolvedError,
    withErrorHandler
  });
};
export const PopulatedModifierGroupClientFactory = _ref2 => {
  let {
    httpClient,
    populationLevel = modifierGroupPopulationLevelNone,
    getResolvedError,
    withErrorHandler
  } = _ref2;
  return createPopulatedModifierGroupClientFactory({
    httpClient,
    populationLevel,
    getResolvedError,
    withErrorHandler
  });
};
//# sourceMappingURL=web.js.map